const Feng = {};

Feng.BASE_URL = "http://xzkjz.systarsoft.com";
// Feng.BASE_URL = "http://192.168.1.105:8099/";

Feng.validatePhone = phone => {
  const reg = /^1(1|2|3|4|5|6|7|8|9)\d{9}$/;
  return reg.test(phone);
};

export default Feng;
